import { Suspense, FC } from 'react';
import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { JsonLD } from './json-ld';
import { OG } from './og';
import { $PoiInfo, $PageLevelTraffic } from 'shared/atoms';
import { usePoiDesc } from '../shared/use-poi-desc';

const PoiHeadInner: FC = () => {
  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();
  const { name } = useAtomValue($PoiInfo(poiId));
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  const { title, description } = usePoiDesc();
  const keywords = `#${name}`;

  const fb_appid = 426786581540674;

  return (
    <>
      <title>{title}</title>
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="description" name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="fb:app_id" content={String(fb_appid)} />
      <JsonLD />
      <OG />
    </>
  );
};

export const PoiHead: FC = () => {
  return (
    <Suspense fallback={<></>}>
      <PoiHeadInner />
    </Suspense>
  );
};
